import { render, staticRenderFns } from "./DownArrowIcon.vue?vue&type=template&id=25420fac&scoped=true"
import script from "./DownArrowIcon.vue?vue&type=script&lang=js"
export * from "./DownArrowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25420fac",
  null
  
)

export default component.exports